export default {
  pageHeroV1: {
    container: {
      height: '75vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      marginBottom: '10rem'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      position: 'absolute',
      bottom: '0rem',
      transform: 'translateY(110%)',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem',
        fontFamily: 'heading',
        fontWeight: 'normal',
        color: 'secondary'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
